import { getLocaleCode } from "../translate/locale";

const UNITS = ["B", "KB", "MB", "GB", "TB"];

// Tamanho em bytes → "2,8 GB" (base 1024, até uma casa decimal).
export const formatBytes = (bytes) => {
  let size = Number(bytes) || 0;
  let unit = 0;
  while (size >= 1024 && unit < UNITS.length - 1) {
    size /= 1024;
    unit += 1;
  }
  const value = size.toLocaleString(getLocaleCode(), {
    maximumFractionDigits: unit === 0 ? 0 : 1,
  });
  return `${value} ${UNITS[unit]}`;
};

export default formatBytes;
